module.exports = __webpack_public_path__ + "static/img/banner3.0bc6f0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/banner3.png
// module id = qjoL
// module chunks = 127